export default __webpack_public_path__ + "1c9eed3f630d96e50043829d56de5afb.svg";